// extracted by mini-css-extract-plugin
module.exports = {"contentBox":"dZ","contentFrame":"d0","buttonGroup":"d1","button":"d2","header":"d3","text":"d4","contentImage":"d5","closeButton":"d6"};